export namespace Preference {
    export const KEY = "preference";

    export enum Lab {
        DevMode = "Development Mode",
        PageFeedback = "PageFeedback",
        WMLAutoAddContacts = "WML Auto-Add Contacts",
        DecisionTreeEnhancement = "Decision Tree Enhancement",
        PermissionsBaseline = "Permissions Baseline Reminders",
        SharedPageLibraryAdmin = "Shared Page Library Admin",
        SelectivePublish = "Selective Container Publish",
        PageLevelEditors = "Page Level Editors",
        SecondaryPageOwners = "Secondary Page Owners",
    }
    export class Value {
        userId: string;
        instanceId: string;
        labs: Set<Lab>;
    }
}
